module.exports = __webpack_public_path__ + "assets/blue-download-thick.61ab6a5d534096116dc5459004b8b62f.svg";